<template>
    <div>
        <v-chip @click="showImage(id)" color="yellow" small class="mr-1 mb-1">
            <viewer
                :images="data.images"
                :class="'viewer' + id"
                :id="'viewer' + id"
                ref="viewer"
                @inited="inited"
            >
                <img
                    v-for="src in data.images"
                    :src="src"
                    :key="src"
                    class="image"
                />
            </viewer>
            <v-icon left small>mdi-file-image</v-icon>
            {{ title }}
        </v-chip>
    </div>
</template>
<script>
import Viewer from "v-viewer/src/component.vue"

export default {
    components: {
        Viewer,
    },
    props: ["id", "data", "title"],
    data() {
        return {
            view: [],
        }
    },
    mounted() {
        // console.log(this.title);
        this.title = this.title === undefined ? "View Image" : this.title
    },
    methods: {
        inited(viewer) {
            this.view.push(viewer)
        },
        showImage(id) {
            this.view.map((each) => {
                if (each.element.id == "viewer" + id) {
                    this.$viewer = each
                    this.$viewer.show()
                }
            })
        },
    },
}
</script>
<style scoped>
.image {
    display: none;
}
</style>
